import { env } from '@/root/env.mjs';

import { type UiConfig } from './uiConfigTypes';
import { uiDevConfig } from './uiDev.config';
import { uiProdConfig } from './uiProd.config';
import { uiStageConfig } from './uiStage.config';

export function getDefaultConfig(): UiConfig {
  switch (env.NEXT_PUBLIC_ENVIRONMENT) {
    case 'production':
      return uiProdConfig;
    case 'stage':
      return uiStageConfig;
    case 'dev':
    default:
      return uiDevConfig;
  }
}
